import {request} from '@/helpers/apiClient'
import { CATEGORY_CONFIG } from '@/utils/constants/apiConfig/categoryConfig'

export const getCategoryList = async (dropdownType) => {
  // For backward compatibility: if no dropdownType, use the old endpoint
  if (!dropdownType) {
    return request(CATEGORY_CONFIG.CATEGORY_LIST)
  }
  // Otherwise use the new dropdown endpoint
  return request(CATEGORY_CONFIG.CATEGORY_DROPDOWN_LIST(dropdownType))
}
